<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          class="shrink mr-2"
          contain
          src="./assets/badge.gif"
          transition="scale-transition"
          width="40"
        />

        <h1>Police News</h1>
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
<div style="height:65px;background-color:black">
  <h1>test</h1>
</div>
<hr/><hr/>
    <v-treeview
    v-model="tree"
    :open="initiallyOpen"
    :items="folders"
    activatable
    item-key="name"
    open-on-click
  >
    <template v-slot:prepend="{ item, open }">
      <v-icon v-if="!item.file">
        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
      </v-icon>
      
      <v-btn :href="item.path" v-else>
        <v-icon >
        {{ files[item.file] }}
        </v-icon>
      </v-btn>
    </template>
  </v-treeview>

  </v-app>
</template>

<script>
import axios from 'axios'


export default {
  name: 'App',

  components: {
   
  },

  data: () => ({
    initiallyOpen: ['public'],
      tree:[],
      folders:{},
      files: {
        html: 'mdi-language-html5',
        js: 'mdi-nodejs',
        json: 'mdi-code-json',
        md: 'mdi-language-markdown',
        pdf: 'mdi-file-pdf',
        png: 'mdi-file-image',
        txt: 'mdi-file-document-outline',
        xls: 'mdi-file-excel',
        php: 'mdi-file-cog',
        jpg: 'mdi-image',
        css: 'mdi-language-css3',
        mp4: 'mdi-filmstrip',
        mp3: 'mdi-music-box'
      },
      items2:[{name: '.git',},{name: 'node_modules',},{name: 'public',children: [{name: 'static',children: [{name: 'logo.png',file: 'png',}],},{name: 'favicon.ico',file: 'png',},{name: 'index.html',file: 'html'}]},{name: '.gitignore',file: 'txt'},{name: 'babel.config.js',file: 'js'},{name: 'package.json',file: 'json',},{name: 'README.md',file: 'md',},{name: 'vue.config.js',file: 'js',}],
      items: [{"name":"08-04-20_PressRelease.pdf","file":"pdf","path":"./08-04-20_PressRelease.pdf"},{"name":"folders.php","file":"php","path":"./folders.php"},{"name":"index.php","file":"php","path":"./index.php"},{"name":"index_backup.php","file":"php","path":"./index_backup.php"},{"name":"KCIRT.jpg","file":"jpg","path":"./KCIRT.jpg"},{"name":"OIS_020621","children":[{"name":"2-6-21_OIS_MediaRelease_01.pdf","file":"pdf","path":"./OIS_020621/2-6-21_OIS_MediaRelease_01.pdf"},{"name":"2-6-21_OIS_MediaRelease_02.pdf","file":"pdf","path":"./OIS_020621/2-6-21_OIS_MediaRelease_02.pdf"},{"name":"2-6-21_OIS_MediaRelease_03.pdf","file":"pdf","path":"./OIS_020621/2-6-21_OIS_MediaRelease_03.pdf"},{"name":"2-6-21_OIS_MediaRelease_04.pdf","file":"pdf","path":"./OIS_020621/2-6-21_OIS_MediaRelease_04.pdf"},{"name":"2-6-21_OIS_MediaRelease_05.pdf","file":"pdf","path":"./OIS_020621/2-6-21_OIS_MediaRelease_05.pdf"},{"name":"2-6-21_OIS_MediaRelease_06.pdf","file":"pdf","path":"./OIS_020621/2-6-21_OIS_MediaRelease_06.pdf"},{"name":"2-6-21_OIS_MediaRelease_07.pdf","file":"pdf","path":"./OIS_020621/2-6-21_OIS_MediaRelease_07.pdf"},{"name":"2-6-21_OIS_MediaRelease_08.pdf","file":"pdf","path":"./OIS_020621/2-6-21_OIS_MediaRelease_08.pdf"},{"name":"index.php","file":"php","path":"./OIS_020621/index.php"}]},{"name":"PoliceNews","children":[{"name":"08-04-20_PressRelease.pdf","file":"pdf","path":"./PoliceNews/08-04-20_PressRelease.pdf"},{"name":"index.php","file":"php","path":"./PoliceNews/index.php"},{"name":"PoliceNews.jpg","file":"jpg","path":"./PoliceNews/PoliceNews.jpg"},{"name":"styles.css","file":"css","path":"./PoliceNews/styles.css"},{"name":"WeeklyUpdate","children":[{"name":"index.php","file":"php","path":"./PoliceNews/WeeklyUpdate/index.php"},{"name":"WeeklyRelease_022521.pdf","file":"pdf","path":"./PoliceNews/WeeklyUpdate/WeeklyRelease_022521.pdf"}]}]},{"name":"styles.css","file":"css","path":"./styles.css"},{"name":"styles_backup.css","file":"css","path":"./styles_backup.css"},{"name":"web.config","file":"config","path":"./web.config"},{"name":"_CopyThisFile_index.php","file":"php","path":"./_CopyThisFile_index.php"}]
  }),

  methods:{
    
    getfolders(){
          let thisvue = this;  	
          this.parcelnumbers=[];
          let url = "https://policenews.bremertonwa.gov/news.php";

          const params = new URLSearchParams();
          
          axios({
              method:"post",
              url:url,
              data:params
            })
            .then(function(response){
              let r=response.data;
              window.console.log(r);
              thisvue.folders = JSON.parse(r);
              });
            },
          },
    mounted() {
            window.scrollTo(0,0);
            this.getfolders();     
    }
}

</script>
